import styled from '@emotion/styled'

export const StyleScrollWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  column-gap: 20px;
  padding-bottom: 5px;
  width: 100%;
  flex-wrap: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`
